import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-380fd682"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "subscribe-content"
};
const _hoisted_2 = {
  class: "category-selector"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-placeholder"
}, null, -1));
const _hoisted_5 = {
  class: "sort-selector"
};
const _hoisted_6 = {
  class: "waterfall-wrapper"
};
const _hoisted_7 = {
  class: "waterfall-column"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "project-image"
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
  key: 0,
  class: "status-tag"
};
const _hoisted_12 = {
  class: "project-info"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "user-info"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "name"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "like-count"
};
const _hoisted_19 = {
  class: "waterfall-column"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "project-image"
};
const _hoisted_22 = ["src", "alt"];
const _hoisted_23 = {
  key: 0,
  class: "status-tag"
};
const _hoisted_24 = {
  class: "project-info"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  class: "user-info"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "name"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "like-count"
};
import { onMounted, reactive, ref, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import env from "md-base-tools/env";
import { getSubscribeList } from "@/api";
import { mdToast } from "../../utils/tools";
import imgUrlFilter from "md-base-tools/imgUrlFilter";
import MDRouter from "../../service/router";
export default {
  setup(__props) {
    const route = useRoute();
    const categoryListRef = ref(null); // 滚动容器的引用

    const state = reactive({
      page: 1,
      page_size: 20,
      proList: [],
      category: '全部',
      //默认分类
      sort: 'new',
      // 默认排序
      // 分类列表
      categoryList: ['全部', '潮玩', '桌游', '卡牌', '游戏', '设计', '文玩', '食品', '出版'],
      // 排序列表
      sortList: [{
        name: '最新',
        value: 'new'
      }, {
        name: '看好',
        value: 'favor'
      }, {
        name: '评论',
        value: 'comment'
      }].map(item => ({
        ...item,
        className: computed(() => state.sort === item.value ? 'sort-item-active' : '')
      })),
      refreshing: false,
      is_next: true,
      loading: false,
      request_finished: false,
      categoryItemRefs: [],
      // 存储每个分类项的DOM引用
      showSortSheet: false // 控制排序弹出层的显示
    });

    // 获取当前排序方式的显示名称
    const getCurrentSortName = computed(() => {
      const currentSort = state.sortList.find(item => item.value === state.sort);
      return currentSort ? currentSort.name : '最新';
    });

    // 左列项目
    const leftColumnProjects = computed(() => {
      return state.proList.filter((_, index) => index % 2 === 0);
    });

    // 右列项目
    const rightColumnProjects = computed(() => {
      return state.proList.filter((_, index) => index % 2 === 1);
    });
    onMounted(async () => {
      state.is_ip = route.query.is_ip == 1 ? true : false;
      await requestSubscribeList();

      // 等待DOM更新后居中第一个选中项
      nextTick(() => {
        centerSelectedItem(state.category);
      });
    });

    // 下拉刷新
    async function onRefresh() {
      state.page = 1;
      state.loading = true;
      state.request_finished = false;
      await requestSubscribeList();
    }

    // 上拉加载
    async function onLoadMore() {
      await requestSubscribeList();
    }
    async function requestSubscribeList() {
      const {
        status,
        data,
        message
      } = await getSubscribeList({
        page: state.page,
        page_size: state.page_size,
        category: state.category == '潮玩' ? '潮玩模型' : state.category,
        sort: state.sort // 添加排序参数
      });
      state.loading = false;
      state.refreshing = false;
      state.request_finished = true;
      if (status == 0) {
        if (state.page == 1) {
          state.proList.splice(0, state.proList.length);
        }
        if (data.list && data.list.length > 0) {
          state.proList.push(...data.list);
          state.page++;
          state.is_next = data.is_next;
        }
      } else {
        mdToast(message);
      }
    }

    // 分类选择处理
    const handleCategorySelect = async item => {
      if (state.category !== item) {
        state.category = item;
        state.proList = [];

        // 等待DOM更新后滚动到中心位置
        nextTick(() => {
          centerSelectedItem(item);
        });
        onRefresh();
      }
    };

    // 将选中项滚动到居中位置
    const centerSelectedItem = selectedCategory => {
      if (!categoryListRef.value) return;

      // 找到选中项的索引
      const selectedIndex = state.categoryList.indexOf(selectedCategory);
      if (selectedIndex === -1) return;

      // 获取选中项的DOM元素
      const selectedElement = state.categoryItemRefs[selectedIndex];
      if (!selectedElement) return;
      const container = categoryListRef.value;

      // 计算目标滚动位置
      const containerRect = container.getBoundingClientRect();
      const itemRect = selectedElement.getBoundingClientRect();

      // 滚动到使选定项目居中的位置
      const scrollLeft = itemRect.left - containerRect.left - containerRect.width / 2 + itemRect.width / 2;

      // 使用平滑滚动效果
      container.scrollTo({
        left: container.scrollLeft + scrollLeft,
        behavior: 'smooth'
      });
    };

    // 显示排序选项
    const showSortSheet = () => {
      state.showSortSheet = true;
    };

    // 处理排序选择
    const handleSortSelect = item => {
      if (state.sort !== item.value) {
        state.sort = item.value;
        onRefresh();
      }
      state.showSortSheet = false;
    };

    // 处理项目点击
    const handleProjectClick = item => {
      if (env.isModianIos() || env.isModianAndroid()) {
        checkVersion(item);
      } else {
        MDRouter.goProInfo(item.pro_id);
      }
    };
    const checkVersion = item => {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "onGetUserInfo",
        functionParams: {},
        callBack: e => {
          console.log('e------>', e);
          if (Number(e.data.build) < 62504101) {
            //提示升级
            checkIfLatestVersion();
          } else {
            MDRouter.goProInfo(item.pro_id);
          }
        }
      });
    };
    const checkIfLatestVersion = () => {
      mdToast('当前版本无法查看');

      /*
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://checkLatest`,
        webFun: () => {}
        })
      */
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_Error = _resolveComponent("Error");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "category-list",
        ref_key: "categoryListRef",
        ref: categoryListRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).categoryList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['category-item', {
            active: _unref(state).category === item
          }]),
          onClick: $event => handleCategorySelect(item),
          ref_for: true,
          ref: el => {
            if (el) _unref(state).categoryItemRefs[index] = el;
          }
        }, _toDisplayString(item), 11, _hoisted_3);
      }), 128)), _hoisted_4], 512), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
        class: "sort-text",
        onClick: showSortSheet
      }, _toDisplayString(_unref(getCurrentSortName)), 1), _createVNode(_component_van_icon, {
        name: "arrow-down",
        onClick: showSortSheet
      })])]), _createVNode(_component_van_action_sheet, {
        show: _unref(state).showSortSheet,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => _unref(state).showSortSheet = $event),
        description: "排序",
        actions: _unref(state).sortList,
        onSelect: handleSortSelect,
        "cancel-text": "取消"
      }, null, 8, ["show", "actions"]), _unref(state).proList.length > 0 ? (_openBlock(), _createBlock(_component_van_pull_refresh, {
        key: 0,
        modelValue: _unref(state).refreshing,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(state).refreshing = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          class: "list",
          loading: _unref(state).loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = $event => _unref(state).loading = $event),
          finished: !_unref(state).is_next,
          "immediate-check": false,
          onLoad: onLoadMore
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftColumnProjects), item => {
            return _openBlock(), _createElementBlock("div", {
              class: "list-card",
              key: item.id
            }, [_createElementVNode("div", {
              class: "card-content",
              onClick: $event => handleProjectClick(item)
            }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
              src: _unref(imgUrlFilter)(item.logo, 375),
              alt: item.title
            }, null, 8, _hoisted_10), _unref(state).category === '全部' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.category), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
              class: "icon",
              src: _unref(imgUrlFilter)(item.user_info.icon, 36)
            }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, _toDisplayString(item.user_info.nickname), 1), _createElementVNode("img", {
              class: "favor-icon",
              src: _unref(imgUrlFilter)('https://p6.moimg.net/mdwxapp/subscribe_favor_icon.png', 26)
            }, null, 8, _hoisted_17), _createElementVNode("span", _hoisted_18, _toDisplayString(item.favor_num), 1)])])], 8, _hoisted_8)]);
          }), 128))]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightColumnProjects), item => {
            return _openBlock(), _createElementBlock("div", {
              class: "list-card",
              key: item.id
            }, [_createElementVNode("div", {
              class: "card-content",
              onClick: $event => handleProjectClick(item)
            }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
              src: _unref(imgUrlFilter)(item.logo, 375),
              alt: item.title
            }, null, 8, _hoisted_22), _unref(state).category === '全部' ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.category), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
              class: "icon",
              src: _unref(imgUrlFilter)(item.user_info.icon, 36)
            }, null, 8, _hoisted_27), _createElementVNode("div", _hoisted_28, _toDisplayString(item.user_info.nickname), 1), _createElementVNode("img", {
              class: "favor-icon",
              src: _unref(imgUrlFilter)('https://p6.moimg.net/mdwxapp/subscribe_favor_icon.png', 26)
            }, null, 8, _hoisted_29), _createElementVNode("span", _hoisted_30, _toDisplayString(item.favor_num), 1)])])], 8, _hoisted_20)]);
          }), 128))])])]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"])) : _unref(state).request_finished ? (_openBlock(), _createBlock(_component_Error, {
        key: 1,
        style: {
          height: '100%'
        },
        message: "什么都没有哦",
        class: "empty-box"
      })) : _createCommentVNode("", true)]);
    };
  }
};